//@flow

import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_PRODUCT_VISIBILITY: `${env.baseApiUrl}/ui/admin/store/products-visibility-setting`,
  SET_PRODUCT_VISIBILITY: `${env.baseApiUrl}/ui/admin/store/products-visibility-setting`,
});

export const getProductVisibilityApi = getCreator(
  endpoints.GET_PRODUCT_VISIBILITY
);

export const setProductVisibilityApi = postCreator(
  endpoints.SET_PRODUCT_VISIBILITY
);
